<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-tabs
                app
                show-arrows
                :height="32"
				class="tabs-route"
                background-color="transparent"
                slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/tickets/contracts/' + id + '/'}" key="contracts" >{{ $trans('contract') }}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/tickets/contracts/' + id + '/tickets', query: { company_id: model.company_id }}" key="tickets">Ticket</v-tab>
                <v-tab v-if="model.contract_type === 'carnet'" exact-path ripple :to="{ path: '/tickets/contracts/' + id + '/movements'}" key="movements">Movimenti Ore</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>
        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'contract-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.model ? ['name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' / ') : ''
            }
        },        

        created() {
            this.$store.commit('endProgress')
            this.axios.get('contracts/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model

            }, response => {
                // error callback
            })
        },
    }
</script>
